import { ReturnReasonCodeResource, CreateReturnReasonRequest, UpdateReturnReasonRequest  } from "../api/barcodeSystem/returnReasonCode";

export class EditReturnReasonModel {
    isNew: boolean;
    code: string;
    description: string;
    visible: boolean = false;
    loading: boolean = true;
    saving: boolean = false;

    showForNewReturnReason() {
        this.isNew = true;
        this.loading = false;
    }

    showForExistingReturnReason(returnReason: ReturnReasonCodeResource) {
        this.isNew = false;
        this.loading = false;
        this.code = returnReason.code;
        this.description = returnReason.description;
    }

    toCreateReturnReasonRequest(): CreateReturnReasonRequest {
        return { 
          code: this.code, 
          description: this.description
        };
    }

    toUpdateReturnReasonRequest(): UpdateReturnReasonRequest {
        return {
          code: this.code, 
          description: this.description
        };
    }
}
